import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BadDataModalContainer, type DataTableModalProps,
} from './badDataModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BadDataTable: DataTableModalProps;
  }
}
modalRenderer.register('BadDataTable', BadDataModalContainer);
